import { render, staticRenderFns } from "./Resumes.vue?vue&type=template&id=712bbb72&scoped=true"
import script from "./Resumes.vue?vue&type=script&lang=ts"
export * from "./Resumes.vue?vue&type=script&lang=ts"
import style0 from "./Resumes.vue?vue&type=style&index=0&id=712bbb72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712bbb72",
  null
  
)

export default component.exports